<template>
  <div class="shop-select">
    <BaseElSelect
      v-model="syncModel"
      value-key="id"
      multiple
      clearable
      collapse-tags
      :placeholder="$t('adminSetting.form.branch.placeholder')"
      :no-data-text="$t('common.table.empty.text')"
      @change="$emit('change')"
    >
      <BaseElSelectOption
        v-for="item in shopList"
        :key="item.id"
        :label="`${item.name} (${item.id.slice(-5)})`"
        :value="item"
      />
    </BaseElSelect>
  </div>
</template>

<script>
import { GetShops, GetShopsCount } from '@/api/shop'
export default {
  name: 'ShopMultiSelect',
  props: ['model', 'unitId'],

  data: () => ({
    shopList: [],
  }),

  computed: {
    syncModel: {
      get () {
        return this.model
      },
      set (data) {
        this.$emit('update:model', data)
      },
    },
  },

  async mounted () {
    await this.getAllShops()
  },

  methods: {
    async getAllShops () {
      try {
        const count = await GetShopsCount({})
        let start = 0
        const limit = 50
        const seen = new Set()

        const firstPage = await GetShops({ start, limit })
        firstPage.forEach(shop => seen.add(shop.id))
        this.shopList = firstPage

        while (this.shopList.length < count) {
          start += limit
          const next = await GetShops({ start, limit })
          const fresh = next.filter(shop => !seen.has(shop.id))
          if (fresh.length === 0) break
          fresh.forEach(shop => seen.add(shop.id))
          this.shopList.push(...fresh)
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
